module.exports = __webpack_public_path__ + "static/media/casinonight.e387c5ad.jpeg";